/** @jsxImportSource @emotion/react */

import Typography from '@mui/material/Typography'
import { FC } from 'react'
import { Avatar } from '@mui/material'
import * as classes from 'pagesNew/TeamMembers/TeamMembersPlatformList/styles'
import { searchTeamMember_searchTeamMember_items as SearchedAuthor } from '__generatedTypes__/searchTeamMember'

type Props = {
  author: SearchedAuthor
}

export const AuthorRenderItem: FC<Props> = ({ author }) => (
  <div css={classes.renderItem}>
    <div css={classes.block}>
      <div css={classes.avatar}>
        <Avatar src={author.getAvatar.photo || ''} css={classes.avatar} alt="Storyteller avatar" />
      </div>
      <Typography variant="body2" css={classes.longText}>
        {author.fullName}
      </Typography>
    </div>
  </div>
)
